import type { ReactNode } from 'react';

type DesktopContainerProps = {
  children?: ReactNode;
};

export const DesktopContainer = ({ children }: DesktopContainerProps) => {
  return (
    <nav className="hidden lg:block">
      <div className="w-full">{children}</div>
    </nav>
  );
};
